module.exports = (require("./helpers/browser/import-polyfill")(require('./helpers/bundle-manifest').resolve("8WnsM"))).then(() => parcelRequire('30CCJ'));